module.exports = __webpack_public_path__ + "media/images/app/plan-99ac03ec6afdc76d4cdca45953826e1f.svg";